import HebrewDefinition from '../definitions/HebrewDefinition';
import Morphology from '../morphology/Morphology';
import Source from '../sources/Source';
import SourceCodes from '../sources/SourceCodes';
import SourceTestament from '../sources/SourceTestament';
import SourceTypes from '../sources/SourceTypes';
import Server from './Server';

interface RawHebrewDefinition {
    word: string;
    simpleWord: string;
    definitions: string[];
}

interface RawMorphology {
    code: string;
    description: string;
}

interface RawSource {
    index: number;
    code: string;
    name: string;
    type: string;
    testament: string;
}

interface RawAppData {
    hebrewDefinitions: RawHebrewDefinition[];
    morphology: RawMorphology[];
    sources: RawSource[];
}

export interface AppData {
    hebrewDefinitions: HebrewDefinition[];
    morphology: Morphology[];
    sources: Source[];
}

export default class AppDataLoader {

    public static load(): Promise<AppData> {
        return Server.newRequest().get<RawAppData>('app-data').then(data => {
            return {
                hebrewDefinitions: data.hebrewDefinitions.map(this.newHebrewDefinition),
                morphology: data.morphology.map(this.newMorphology),
                sources: data.sources.map(this.newSource)
            };
        });
    }

    private static newHebrewDefinition(definition: RawHebrewDefinition): HebrewDefinition {
        return new HebrewDefinition(definition);
    }

    private static newMorphology(morphology: RawMorphology): Morphology {
        return new Morphology(morphology);
    }

    private static newSource(source: RawSource): Source {
        return new Source({
            code: SourceCodes.fromString(source.code),
            index: source.index,
            name: source.name,
            type: SourceTypes.fromString(source.type),
            testament: source.testament as SourceTestament
        });
    }
}
